<div class="c-media">
  <div class="c-list-image" style="margin-left: 0px; margin-right: 5px">
    <div v-if="!readonly" class="icon-thumbnail">
      <div v-if="newValue && newValue.length" class="row">
        <c-img
          @update:src="onConfirmDelete"
          :src="newValue"
          :readonly="readonly"
          class="w50 h50 cover icon-media icon-radius"
          :class="class"
          code="key"
        />
        <span @click="onConfirmDelete('')" class="delete-icon">&#x2715;</span>
      </div>
      <img
        v-else
        @click="onBrowseFile"
        :src="uploadIcon"
        class="icon-media"
        alt=""
      />
    </div>
    <div v-else class="icon-thumbnail mr5">
      <c-img
        v-if="newValue && newValue.length"
        @update:src="onConfirmDelete"
        :src="newValue"
        :readonly="readonly"
        class="w30 h30 cover icon-radius icon-media"
        code="key"
      />
      <img v-else :src="uploadIcon" class="icon-media" alt="" />
    </div>
  </div>

  <c-modal
    @onClose="onCloseBrowseFile"
    @onConfirm="onUpdateValue"
    labelText="componentSelectMedia"
    :active="isModal"
    modalSize="modal-lg"
    isText
    isOverlay
  >
    <template v-slot:modal="{ row }">
      <div class="row c-modal-select-media">
        <div class="left">
          <div class="row">
            <div
              v-for="tab in tabFolders"
              :key="tab"
              class="col-12"
              style="float: left"
            >
              <div
                @click="onTabChange(tab?.code)"
                :class="{'active': activeFolder === tab?.code}"
                class="nav-link"
              >
                {{ $t(tab?.value) }}
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div
            v-if="activeFolder === 'C001' && !isDirectory?.code"
            class="row animate-bottom"
          >
            <media-from-computer
              :isArray="isArr"
              @selectedMedia="onSelectMediaOnly"
            ></media-from-computer>
          </div>
          <div
            v-if="activeFolder === 'S001' && !isDirectory?.code"
            class="row animate-bottom p5"
          >
            <div class="wrapper-folder">
              <div
                v-for="folder in folders"
                @click="goDirectory(folder)"
                :key="folder"
                class="card-folder"
              >
                <div class="card-folder-logo">
                  <img
                    :src="require('@/assets/icons/sidebars/folder.svg')"
                    alt=""
                  />
                </div>
                <div class="card-folder-title">
                  <span>{{ folder?.title || "N/A" }}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isDirectory?.code" class="row">
            <div class="directory-header">
              <span>
                <img
                  src="@/assets/icons/sidebars/go-left.svg"
                  class="bg-primary w25 h25 radius10 pointer mr10"
                  @click="goBackDirectory"
                />
                <span
                  >{{ isDirectory?.title }}
                  <small class="txt-secondary"
                    >({{ form.code && isArr ? form.code.length :
                    (form.code.length ? [form.code].length : 0) }})</small
                  ></span
                >
              </span>
            </div>
            <div
              @scroll="handleScroll"
              ref="listMediaBody"
              class="directory-list"
            >
              <!-- <div v-if="isDirectoryLoading" class="row animate-bottom p5 is-loading">
                  
                </div> -->
              <div class="row">
                <div v-if="directoriesImage.length" class="row">
                  <div
                    v-for="direct in directoriesImage"
                    class="directory-card"
                  >
                    <input
                      v-model="form.code"
                      :value="direct.key"
                      @change="onChangeSelected"
                      :type="isArr ? 'checkbox' : 'radio'"
                      :multiple="isArr"
                      class="input-checkbox"
                    />
                    <c-img
                      :isOnLoading="isDirectoryLoading"
                      :src="$helper?.getFullImage(direct?.key)"
                      class="detail-img"
                    />
                  </div>
                </div>
                <div
                  v-else-if="!isDirectoryLoading && !directoriesImage.length"
                  class="row animate-bottom p5 is-loading"
                >
                  <c-empty></c-empty>
                </div>
                <div v-if="isDirectoryLoading" class="col-12 mt10">
                  <c-loading :loading="true"></c-loading>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </c-modal>
</div>
